import { Link, NavLink } from "react-router-dom";
import { Box, Button, ButtonProps, styled } from "@mui/material";
import logo from "../../images/tublianLogo.svg";
import darkLogo from "../../images/logo_text_dark.svg";
import podcastBg from "../../images/podcastBg.png";
import { podcastSvg } from "../UserHome/Base/SVG";

const Footer = ({ darkMode = false }) => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterWrap>
        <BgContainer>
          <LogoContainer to="/">
            <img alt="logo" src={darkMode ? darkLogo : logo} />
          </LogoContainer>

          <LinkContainer darkMode={darkMode?.toString()}>
            <Header darkMode={darkMode?.toString()}>Links</Header>

            <Link to="/manifesto">Manifesto</Link>
            <a
              href="https://blog.tublian.com/"
              target="_blank"
              rel="noreferrer"
            >
              Blog
            </a>
            <Link to="/streetcred">What is Streetcred?</Link>
            <Link to="/freelancer-internship">Freelancer Internship</Link>
          </LinkContainer>
          <LinkContainer darkMode={darkMode?.toString()}>
            <Header darkMode={darkMode?.toString()}>Socials</Header>

            <a
              href="https://www.linkedin.com/company/tublian"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>
            <a
              href="https://twitter.com/tublian"
              target="_blank"
              rel="noreferrer"
            >
              Twitter
            </a>
            <a
              href="https://www.youtube.com/channel/UCrK_of2nLDdw6BBVGucbM_w"
              target="_blank"
              rel="noreferrer"
            >
              Youtube
            </a>
            <a
              href="https://discord.gg/S6KGq3NR7F"
              target="_blank"
              rel="noreferrer"
              style={{ width: "241px" }}
            >
              Join our community on Discord
            </a>
          </LinkContainer>
        </BgContainer>
        <PodcastContainer>
          <ImageBox>
            <StyledImage src={podcastBg}></StyledImage>
          </ImageBox>
          <Box>
            <StyledButton
              component="a"
              href="https://www.youtube.com/@tublian1666/podcasts"
              target="_blank"
              rel="noopener noreferrer"
              startIcon={podcastSvg}
            >
              Listen Now
            </StyledButton>
          </Box>
        </PodcastContainer>
      </FooterWrap>
      <Copyright darkMode={darkMode?.toString()}>
        <footer>
          {currentYear} Tublian Company Group. All right reserved.
        </footer>
        <CopyrightLinks darkMode={darkMode?.toString()}>
          <a href="/privacy">Privacy policy</a>
          <a href="/terms">Terms of use</a>
        </CopyrightLinks>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  position: "relative",
  zIndex: 2,
  margin: "auto",
}));

const BgContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  gap: "57px",
  [theme.breakpoints.down(1200)]: {
    gap: "40px",
  },
  [theme.breakpoints.down(1150)]: {
    flexDirection: "column",
    margin: 0,
    gap: "40px",
    width: "100%",
  },
}));

const PodcastContainer = styled(Box)(({ theme }) => ({
  width: "407px",
  height: "154px",
  background: "#5670D7",
  borderRadius: "20px",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  overflow: "hidden",
  [theme.breakpoints.down(1150)]: {
    flexDirection: "column",
    gap: "10px",
    height: "100%",
    alignItems: "flex-start",
  },
  [theme.breakpoints.down(450)]: {
    width: "100%",
  },
}));

const ImageBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down(1150)]: {
    height: "100%",
    width: "100%",
  },
}));

const StyledImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",

  maskImage:
    "linear-gradient(to right, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0) 100%)",
  WebkitMaskImage:
    "linear-gradient(to right, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0) 100%)",
  [theme.breakpoints.down(1150)]: {
    maskImage:
      "linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 1) 90%, rgba(0, 0, 0, 0) 100%)",
    WebkitMaskImage:
      "linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 1) 90%, rgba(0, 0, 0, 0) 100%)",
  },
}));

const StyledButton = styled(Button)<ButtonProps & React.ComponentProps<"a">>(
  ({ theme }) => ({
    marginRight: "20px",
    background: "linear-gradient(to bottom, #98A9ED 0%, #6B85ED 100%)",
    color: "#fefefe",
    border: "1px solid #B2BEED",
    padding: "8px 16px",
    borderRadius: "20px",
    fontSize: "1rem",
    lineHeight: "1.5rem",
    fontWeight: 500,
    [theme.breakpoints.down(1150)]: {
      marginRight: "0",
      marginLeft: "20px",
      marginBottom: "20px",
    },
  })
);

const FooterWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  margin: "0px 0 81px 0",
  padding: "80px 64px 14px 64px",
  gap: "57px",
  [theme.breakpoints.down(1200)]: {
    gap: "40px",
  },
  [theme.breakpoints.down(1150)]: {
    flexDirection: "column",
    gap: "40px",
  },
  [theme.breakpoints.down(768)]: {
    padding: "80px 16px 0",
  },
}));

const LogoContainer = styled(NavLink)(({ theme }) => ({
  [theme.breakpoints.down(900)]: {
    margin: "0 0 8px",
    width: "92px",
  },
}));

const Header = styled("h4")<{ darkMode?: string }>(({ theme, darkMode }) => ({
  color: darkMode === "true" ? "#121212" : "#FEFEFE",
  fontSize: 18,
  fontWeight: 500,
  lineHeight: "30px",
  marginBottom: 4,
}));

const LinkContainer = styled(Box)<{ darkMode?: string }>(({ darkMode }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  "&>a": {
    textDecoration: "none",
    color: darkMode === "true" ? "#696969" : "#B7B7B7",
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "24px",
    "&:hover": {
      color: darkMode === "true" ? "#121212" : "#FEFEFE",
    },
  },
}));

const Copyright = styled(Box)<{ darkMode?: string }>(({ theme, darkMode }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "0 64px 14px 64px",
  [theme.breakpoints.down(900)]: {
    flexDirection: "column-reverse",
    gap: "28px",
  },
  [theme.breakpoints.down(768)]: {
    padding: "20px 16px",
  },
  "&>footer": {
    color: darkMode === "true" ? "#888" : "#696969",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
  },
}));

const CopyrightLinks = styled(Box)<{ darkMode?: string }>(
  ({ theme, darkMode }) => ({
    "&>a": {
      textDecoration: "none",
      color: darkMode === "true" ? "#696969" : "#B7B7B7",
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: "1.5rem",
      "&:hover": {
        color: darkMode === "true" ? "#121212" : "#FEFEFE",
      },
    },
    "& > :not(:last-child)": {
      marginRight: "18px",
    },
    [theme.breakpoints.down(900)]: {
      marginTop: "40px",
    },
  })
);
